import { render, staticRenderFns } from "./regstar.vue?vue&type=template&id=99f185e4&"
import script from "./regstar.vue?vue&type=script&lang=js&"
export * from "./regstar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports